// frontend/src/components/MessageBox.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

// showLoginButton: Boolean, der steuert, ob der Login-Button angezeigt wird
// onLoginRedirect: Funktion, die aufgerufen wird, wenn der Login-Button geklickt wird
const MessageBox = ({ message, onClose, showLoginButton, onLoginRedirect }) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="message-box-title"
      aria-describedby="message-box-description"
    >
      <DialogTitle id="message-box-title">
        Hinweis
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="message-box-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
        {showLoginButton && (
          <Button onClick={onLoginRedirect} variant="contained" color="primary" autoFocus>
            Anmelden
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MessageBox;
